//@flow
import * as React from "react";
import Scroll from "react-scroll";
import s from "./TableNav.less";

type Props = {
  name: string,
  children: React.Node
};

const TableNavLink = (props: Props) => (
  <Scroll.Link
    to={props.name}
    spy={true}
    hashSpy={true}
    smooth={"easeInOutExpo"}
    offset={-80}
    duration={600}
    activeClass={`${s.activeNav}`}
  >
    {props.children}
  </Scroll.Link>
);

export default TableNavLink;



// WEBPACK FOOTER //
// ./src/components/Navigation/TableNavLink.js